// Типы для токенов
export interface PayBlagoTourizmTokensRequest {
    user_id: number;
    amount: number;
}

export const tokenEndpoints = {
    payBlagoTourizmTokens: {
        query: (data: PayBlagoTourizmTokensRequest) => ({
            url: "/admin/special/pay-blago-tourizm-tokens",
            method: "POST",
            body: data,
        }),
    },
};

export const tokenTags = ["Tokens"] as const;
